module.exports = __webpack_public_path__ + "static/media/background-header@2x.ecafa4d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-header@2x.jpg
// module id = 393
// module chunks = 0